<!--<div class="app-sidebar" data-active-color="white" data-background-color="grey" data-image="../../../../../wwwroot/assets/img/sidebar-bg/01.jpg">-->
<!--<div class="row">-->
<!--<div class=" container-scroller ps" data-ps-id="764ae016-bf4c-3c30-3a41-6a4ded4a8be6">-->
<div class="container-scroller doNotPrint">
  <!-- Top Navbar Starts-->
  <!---->
  <div id="gotopnurseapp" style="margin-top:0px;">
  </div>
  <div>
    <!--<nav class="navbar navbar-light col-lg-12 col-12 p-0 fixed-top d-flex flex-row k-header">-->
    <nurseapp-navbar></nurseapp-navbar>
    <!--</nav>-->
    <!--</nav>-->

    <div class="container-fluid page-body-wrapper new-color">
      <div class="row row-offcanvas row-offcanvas-right k-sidebar">
        <!--<nav class="sidebar sidebar-offcanvas" id="sidebar" style="max-width:245px;">
          <nurseapp-sidebar></nurseapp-sidebar>
        </nav>-->
        <div class="content-wrapper new-color padding-bottom-0px">
          <router-outlet></router-outlet>
        </div>
        <footer class="footer margin-top-48px bk-lt-gray padding-top-0px padding-bottom-0px">
          <nurseapp-footer></nurseapp-footer>
        </footer>
      </div>
    </div>
  </div>
</div>


<!--<router-outlet></router-outlet>-->
